import _ from "lodash";

import {
	Component,
	EventEmitter,
	OnInit,
	Output,
	ViewChild,
} from "@angular/core";
import { HelperService } from "../../../../services/helper.service";
import { UploadFileApkIpaService } from "./upload-file-apk-ipa-modal.service";
import { finalize, first } from "rxjs/operators";

@Component({
	selector: "upload-file-apk-ipa-modal",
	templateUrl: "./upload-file-apk-ipa-modal.component.html",
	styleUrls: ["./upload-file-apk-ipa-modal.component.scss"],
})
export class UploadFileApkIpaModal implements OnInit {
	@Output() responseSuccess = new EventEmitter();
	@ViewChild("RefModal") localModal;
	@ViewChild("RefFormHtml") RefFormHtml;
	@ViewChild("FileUploadRef") FileUploadRef;

	selectedFile = [];

	constructor(
		private helperService: HelperService,
		public uploadService: UploadFileApkIpaService
	) {}

	ngOnInit(): void {}

	openModal(selectedTools) {
		this.selectedFile = [...this.selectedFile];
		this.localModal.show();
	}

	getSaveValidationMessages() {
		let invalidFieldMessage = [];

		return invalidFieldMessage;
	}

	uploadFiles(event) {
		let { files } = event;

		_.each(this.RefFormHtml.controls, (formControlRef, index) => {
			formControlRef.markAsDirty();
		});

		let invalidFieldMessage = this.getSaveValidationMessages();
		if (invalidFieldMessage.length > 0) {
			this.helperService.errorMessage(invalidFieldMessage[0]);
			return;
		}
		if (files.length === 0) {
			this.helperService.errorMessage("File is required");
			return;
		}
		const validExtensions = ["apk", "ipa"];
		let invalidFiles = _.filter(files, (file) => {
			const fileExtension = file.name.split(".").pop().toLowerCase();
			return !validExtensions.includes(fileExtension);
		});

		if (invalidFiles.length > 0) {
			this.helperService.errorMessage(
				"Only APK or IPA files are allowed"
			);
			return;
		}
		let apkFiles = [];
		let ipaFiles = [];

		if (this.uploadService.isUploading()) {
			this.helperService.errorMessage(
				"An upload is already in progress. Please wait until it is finished."
			);
			return;
		}

		// Check file extensions and sort into APK and IPA arrays
		_.each(files, (file) => {
			const fileExtension = file.name.split(".").pop().toLowerCase();
			if (fileExtension === "apk") {
				apkFiles.push(file);
			} else if (fileExtension === "ipa") {
				ipaFiles.push(file);
			}
		});

		// Validate that only one APK and one IPA are allowed
		if (apkFiles.length > 1) {
			this.helperService.errorMessage("Only one APK file is allowed.");
			return;
		}
		if (ipaFiles.length > 1) {
			this.helperService.errorMessage("Only one IPA file is allowed.");
			return;
		}

		let totalToUploadCount = files.length;
		let totalUploadedCount = 0;
		let totalUploadedSuccessCount = 0;
		let uploadedFiles = [];

		_.each(files, (file) => {
			let params = {
				tool_id: 911,
				// tool_id: _.chain(this.selectedFile).map("id").head().value(),
				file: file,
			};
			this.uploadService
				.uploadApkIpaFile(params)
				.pipe(
					first(),
					finalize(() => {
						totalUploadedCount++;
						if (totalUploadedCount == totalToUploadCount) {
							this.FileUploadRef.clear();
							this.responseSuccess.emit({
								uploadedFiles: uploadedFiles,
							});

							if (
								totalUploadedSuccessCount == totalToUploadCount
							) {
								this.uploadService.uploadInProgress$.next(
									false
								);
								this.helperService.successMessage(
									"APK or IPA Successful Uploaded.."
								);
							}
						}
					})
				)
				.subscribe(
					async (response: any) => {
						totalUploadedSuccessCount++;

						uploadedFiles.push(response.data);
					},
					async (error: any) => {
						this.helperService.errorMessage(
							`${file.name} -> ${error}`
						);
					}
				);
		});
		this.localModal.hide();
		this.FileUploadRef.clear();
	}

	onHideModal() {
		this.FileUploadRef.clear();
	}
}
